import { useTranslation } from "@/plugins/i18next/i18next";
import { apolloClient } from "@/plugins/apollo";
import { getCurrentInstance } from "vue";
import gql from "fraql";
export function usePersonRoleMethods() {
    const { t } = useTranslation();
    const instance = getCurrentInstance();
    async function personRevokeRoleInEvent(personRole, event) {
        var _a;
        // @ts-ignore
        const response = await instance.proxy.$root.$confirm(t("events:EventPage.Schedule.OrganiserAndOfficials.deleteConfirm.heading", "Remove staff member from event"), t([
            "events:EventPage.Schedule.OrganiserAndOfficials.deleteConfirm.deleteConfirm.question",
            "Are you sure you want to remove staff / team member {{personName}} from event?"
        ], { personName: (_a = personRole.person) === null || _a === void 0 ? void 0 : _a.name }));
        if (!response)
            return;
        try {
            await apolloClient.mutate({
                mutation: gql `
          mutation personRevokeRoleInEvent($personRoleId: ID!, $eventId: ID!) {
            personRevokeRoleInEvent(
              input: { personRoleId: $personRoleId, eventId: $eventId }
            ) {
              event {
                id
                personRoles {
                  id
                }
              }
            }
          }
        `,
                variables: { personRoleId: personRole.id, eventId: event.id }
            });
            // @ts-ignore
            instance.proxy.$root.$snackbar("success");
        }
        catch (error) {
            // @ts-ignore
            instance.proxy.$root.$snackbarServerError("error", { text: error });
        }
    }
    return {
        personRevokeRoleInEvent
    };
}
export const PersonRoleFragment = gql `
  fragment _ on PersonRole {
    id
    personId
    person {
      id
      name
      firstName
      lastName
    }
    roleId
    role {
      id
      name
    }
  }
`;
